import { chain, client } from "@/contexts/SmartWallet";
import { estimateGas, prepareContractCall } from "thirdweb";
import { getRpcClient, eth_maxPriorityFeePerGas } from "thirdweb/rpc";

// NOTE: In usecases like register/stake operations,
// estimating gas before allowance was granted, caused errors when allowance was insufficient.
// Handled in the calling function by using the vanilla prepareContractCall for the succeeding operation in the batch.

export const customPrepareContractCall = async ({
  contract,
  method,
  params,
  address,
}: any) => {
  const estimateTx = prepareContractCall({
    contract: contract,
    method: method,
    params: params,
  });

  const estimatedGas = await estimateGas({
    transaction: estimateTx,
    from: address,
  });
  const neededGas = estimatedGas * 2n;

  const rpcRequest = getRpcClient({ client: client, chain: chain });
  const maxPriorityFeePerGas = await eth_maxPriorityFeePerGas(rpcRequest);

  const _prepareContractCall = prepareContractCall({
    contract: contract,
    method: method,
    params: params,
    extraGas: neededGas,
    maxFeePerGas: 400000000n,
    maxPriorityFeePerGas: maxPriorityFeePerGas,
  });

  return _prepareContractCall;
};
